import React from 'react';
import { Link } from 'react-router-dom';


const Footer = () => {
	return (
	
  <footer className="site_footer footer_layout_1">
  <div className="content_box" style={{backgroundImage: 'url("assets/images/shapes/bg_pattern_3.svg")'}}>
    <div className="container">
      <div className="diract_contact_links text-white">
        <div className="iconbox_block layout_icon_left">
          <div className="iconbox_icon" style={{backgroundColor: '#23BABF'}}>
            <img src="assets/images/icons/icon_mail.svg" alt="Mail SVG Icon" />
          </div>
          <div className="iconbox_content">
            <h3 className="iconbox_title">Write to us</h3>
            <p className="mb-0">
              Info@workdeskva.com
            </p>
          </div>
        </div>
        <div className="iconbox_block layout_icon_left">
          <div className="iconbox_icon" style={{backgroundColor: '#23BABF'}}>
            <img src="assets/images/icons/icon_calling.svg" alt="Calling Check SVG Icon" />
          </div>
          <div className="iconbox_content">
            <h3 className="iconbox_title"> Call Us (USA)</h3>
            <p className="mb-0">
              +1 (929) 496-5469
            </p>
          </div>
        </div>
        <div className="iconbox_block layout_icon_left">
          <div className="iconbox_icon" style={{backgroundColor: '#23BABF'}}>
            <img src="assets/images/icons/icon_map_mark.svg" alt="Map Mark Check SVG Icon" />
          </div>
          <div className="iconbox_content">
            <h3 className="iconbox_title">Our Office</h3>
            <p className="mb-0">
              Boca Raton FL 33431
            </p>
          </div>
        </div>
      </div>
      <div className="footer_main_content">
        <div className="row justify-content-lg-between">
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="footer_widget pe-md-3">
              <h2 className="footer_info_title">Newsletter</h2>
              <p>
                Sign up to <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span> weekly newsletter to get the latest updates.
              </p>
              <form className="footer_newslatter" action="#">
                <label htmlFor="footer_mail_input">
                  <img src="assets/images/icons/icon_mail_2.svg" alt="Mail SVG Icon" />
                </label>
                <input id="footer_mail_input" type="email" name="email" placeholder="Enter your email" />
                <button type="submit"><i className="fa-solid fa-paper-plane" /></button>
              </form>
              <ul className="social_icons_block unordered_list" style={{marginTop: 30}} data-text="Follow Us:">
                <li>
                  <a href="#!">
                    <i className="fa-brands fa-facebook-f" />
                  </a>
                </li>
                <li>
                  <a href="#!">
                    <i className="fa-brands fa-twitter" />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/workdesk-va/">
                    <i className="fa-brands fa-linkedin-in" />
                  </a>
                </li>
                <li>
                  <a href="#!">
                    <i className="fa-brands fa-dribbble" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="footer_widget">
              <h3 className="footer_info_title">Hire Talent</h3>
              <ul className="icon_list unordered_list_block">
                <li>
                  <Link to="/Aisoftware">
                    <span className="icon_list_text">
                      AI &amp; Software Engineers
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/Digitalmarkiting">
                    <span className="icon_list_text">
                      Digital Marketing
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/Adminsupport">
                    <span className="icon_list_text">
                      Customer Support &amp; Admin
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/TeamServices">
                    <span className="icon_list_text">
                      Team Service
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-6 col-sm-6">
            <div className="footer_widget">
              <h3 className="footer_info_title">Industries We Serve</h3>
              <ul className="icon_list unordered_list_block">
                <li>
                  <Link to="/Ai-data-industry">
                    <span className="icon_list_text">
                      AI &amp; Data
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/It-and-software-industry">
                    <span className="icon_list_text">
                      IT &amp; Software Development
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/startups-and-entrepreneur-industry">
                    <span className="icon_list_text">
                      Startups &amp; Entrepreneurs
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/education-and-coaching-industry">
                    <span className="icon_list_text">
                      Education &amp; Coaching
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-6 col-sm-6">
            <div className="footer_widget">
              <h3 className="footer_info_title">More Industries</h3>
              <ul className="icon_list unordered_list_block">
                <li>
                  <Link to="/marketing-and-advertising-industry">
                    <span className="icon_list_text">
                      Marketing &amp; Advertising
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/healthcare-and-wellness-industry">
                    <span className="icon_list_text">
                      Healthcare &amp; Wellness
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/real-estate-industry">
                    <span className="icon_list_text">
                      Real Estate
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/e-commerce-and-retail-industry">
                    <span className="icon_list_text">
                      E-commerce &amp; Retail
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-6 col-sm-6">
            <div className="footer_widget">
              <h3 className="footer_info_title">Information</h3>
              <ul className="icon_list unordered_list_block">
                <li>
                  <Link to="/">
                    <span className="icon_list_text">
                      Home
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/about">
                    <span className="icon_list_text">
                      About <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span>
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/pricing">
                    <span className="icon_list_text">
                      Pricing
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/blog">
                    <span className="icon_list_text">
                      Blogs
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/contact">
                    <span className="icon_list_text">
                      Contact
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="footer_bottom ">
    <div className="container d-md-flex align-items-md-center justify-content-md-between">
      <p className="copyright_text m-0">
        Copyright © 2025 <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span>, All rights reserved.
      </p>
      <p className="copyright_text m-0">
        <Link to="/support">Support</Link> |
        <Link to="/privacy-policy">Privacy</Link> |
        <Link to="/refund-policy">Refund Policy</Link>
      </p>
    </div>
  </div>
</footer>


	);
};

export default Footer;
